function initializeCalculator() {
  // Get all calculators
  const calculator = document.querySelectorAll(".calculator");
  // Exit if no calculator is found
  if (calculator.length === 0) return;

  // Loop through all calculators
  calculator.forEach((calc) => {
    handleCalculator(calc);
  });

  /* -------------------------------------------------------------------------- */
  /* Calculator logic                                                           */
  /* -------------------------------------------------------------------------- */

  /**
   * Handle the calculator logic
   */
  function handleCalculator(calc) {
    // Get all items of the calculator
    const items = calc.querySelectorAll(".calculator__item");
    // Exit if no items are found
    if (items.length === 0) return;
    // Create dependency table
    const table = {};
    // Loop through all items
    items.forEach((item) => {
      // Get the input field
      const input = item.querySelector(".calculator__item-col--state input");
      // Exit if no input field is found
      if (!input) return;
      // Update the dependency table
      updateDependencyTable(item, table);
      // Listen for changes on the input field
      input.addEventListener("change", (ev) => {
        // Set the dependencies the item might have
        updateDependencies(item, calc, table);
        // Update the total
        updateTotal(calc);
        // Update the state of the button to open the sidebar
        updateSidebarButton(calc);
      });
    });
    setInitialDependencies(calc, table);
    // Set the initial total
    updateTotal(calc);
    // Handle the sidebar
    handleSidebar(calc, table);
    // Update the state of the button to open the sidebar
    updateSidebarButton(calc);
    // Update the state of the submit button
    listenForFormChanges(calc);
  }

  /**
   * Update the state of the sidebar button based on the checked items
   */
  function updateSidebarButton(calc) {
    // Get the sidebar button
    const sidebarButton = calc.querySelector(".calculator__cta a");
    // Get the ids of all checked items
    const ids = getCheckedItems(calc);
    // Check if there are any checked items
    if (ids.length > 0) {
      // Remove the disabled class from the sidebar button
      sidebarButton.classList.remove("button--disabled");
      // Remove the disabled attribute from the sidebar button
      sidebarButton.removeAttribute("disabled");
      // Exit the function
      return;
    }
    // Add the disabled class to the sidebar button
    sidebarButton.classList.add("button--disabled");
    // Add the disabled attribute to the sidebar button
    sidebarButton.setAttribute("disabled", true);
  }

  /**
   * Update the total of the calculator
   */
  function updateTotal(calc) {
    // Get the total field
    const totalField = calc.querySelector(".calculator__total");
    // Exit if no total field is found
    if (!totalField) return;
    // Get the total
    let total = calculateTotal(calc);
    // Check if the total field contains a format attribute
    if (totalField.dataset.format) {
      // Get the format
      const format = totalField.dataset.format;
      // Format the total based on the format
      total = total.toLocaleString(format);
    }
    // Check if the total field contains a suffix attribute
    if (totalField.dataset.suffix) {
      // Get the suffix
      const suffix = totalField.dataset.suffix;
      // Add the suffix to the total
      total += suffix;
    }
    // Set the total
    totalField.innerHTML = total;
  }

  /**
   * Calculate the total of the calculator
   */
  function calculateTotal(calc) {
    // Get all items of the calculator
    const items = calc.querySelectorAll(".calculator__item");
    // Set variable for the total
    let total = 0;
    // Loop through all items
    items.forEach((item) => {
      // Get the input field
      const input = item.querySelector(".calculator__item-col--state input");
      // Exit if no input field is found or if the input field is not checked
      if (!input || !input.checked) return;
      // Get the value if the price field
      let priceField = item.querySelector(".calculator__item-col--sum").innerHTML;
      // Clean all non numeric characters from the price field
      priceField = priceField.replace(/[^0-9]/g, "");
      // Get the value of the price field or set it to 0 if no price field is found
      const price = parseInt(priceField) || 0;
      // Add the price to the total
      total += price;
    });
    return total;
  }

  /**
   * Update the dependency table
   */
  function updateDependencyTable(item, table) {
    // Check if the item has dependencies
    if (!item.dataset.dependencies) return;
    // Get the id of the item
    const id = parseInt(item.dataset.itemId);
    // Get the dependencies
    const dependencies = item.dataset.dependencies.split(",");
    // Loop through all dependencies
    dependencies.forEach((dependency) => {
      // Get the id of the dependency as integer
      dependency = parseInt(dependency);
      // Check if the dependency is already in the table
      if (table[dependency]) {
        // Add the id to the dependency
        table[dependency].push(id);
      } else {
        // Create the dependency in the table
        table[dependency] = [id];
      }
    });
  }

  /**
   * Update the dependencies of an item
   */
  function updateDependencies(item, calc, table) {
    // Get the state of the input field
    const checked = item.querySelector(".calculator__item-col--state input").checked;
    // Get the id of the item
    const id = parseInt(item.dataset.itemId);
    // Check if the item is in the table
    if (!table[id]) return;
    // Get all dependencies of the item
    const dependencies = table[id];
    // Loop through all dependencies
    dependencies.forEach((dependency) => {
      const dependencyItem = calc.querySelector(
        `.calculator__item[data-item-id="${dependency}"]`
      );
      // Exit if no dependency is found
      if (!dependencyItem) return;
      // Update the dependency based on the state of the input field
      if (checked) {
        return enableDependencies(dependencyItem, calc, table);
      }
      disableDependencies(dependencyItem, calc, table);
    });
  }

  /**
   * Enable the dependencies of an item if all dependencies are met
   */
  function enableDependencies(item, calc, table) {
    // Check for nested dependencies
    checkNestedDependencies(item, calc, table);
    // Skip if nested dependencies are found
    if (!checkNestedDependencies(item, calc, table)) return;
    // Get the input field
    const input = item.querySelector(".calculator__item-col--state input");
    // Remove the disabled class from the item
    item.classList.remove("calculator__item--disabled");
    // Remove the disabled attribute from the input field
    input.removeAttribute("disabled");
    // Update the dependencies of the item
    updateDependencies(item, calc, table);
  }

  /**
   * Return if an item has nested dependencies and if they are met
   */
  function checkNestedDependencies(item, calc, table) {
    // Set variavle for return value
    let result = true;
    // Get the id of the item
    const id = parseInt(item.dataset.itemId);
    // Get the keys of the table which contain the id
    const keys = Object.keys(table).filter((key) => {
      return table[key].includes(id);
    });
    // Loop through all keys
    keys.forEach((key) => {
      // Get the item
      const dependencyItem = calc.querySelector(
        `.calculator__item[data-item-id="${key}"]`
      );
      // Exit if no item is found
      if (!dependencyItem) return;
      // Get the input field
      const input = dependencyItem.querySelector(
        ".calculator__item-col--state input"
      );
      // Check if the input field is checked
      if (!input.checked) {
        // Set the result to false
        result = false;
      }
    });
    // Return the result
    return result;
  }

  /**
   * Disable the dependencies of an item
   */
  function disableDependencies(item, calc, table) {
    // Get the input field
    const input = item.querySelector(".calculator__item-col--state input");
    // Make sure the input field is not checked
    input.checked = false;
    // Add the disabled class to the item
    item.classList.add("calculator__item--disabled");
    // Add the disabled attribute to the input field
    input.setAttribute("disabled", true);
    // Update the dependencies of the item
    updateDependencies(item, calc, table);
  }

  /**
   * Set the initial dependencies of the calculator
   */
  function setInitialDependencies(calc, table) {
    // Get all the keys of the table
    const keys = Object.keys(table);
    // Loop through all keys
    keys.forEach((key) => {
      // Get the item
      const item = calc.querySelector(
        `.calculator__item[data-item-id="${key}"]`
      );
      // Exit if no item is found
      if (!item) return;
      // Update the dependencies of the item
      updateDependencies(item, calc, table);
    })
  }

  /* -------------------------------------------------------------------------- */
  /* Sidebar logic                                                              */
  /* -------------------------------------------------------------------------- */

  /**
   * Handle the sidebar logic
   */
  function handleSidebar(calc, table) {
    // Get the sidebar button
    const sidebarButton = calc.querySelector(".calculator__cta a");
    // Listen for clicks on the sidebar button
    sidebarButton.addEventListener("click", (ev) => {
      // Prevent the default behaviour
      ev.preventDefault();
      // Open the sidebar
      openSidebar(calc, table);
    });
    // Get the close button
    const closeButton = calc.querySelector(".calculator-sidebar__close");
    // Listen for clicks on the close button
    closeButton.addEventListener("click", (ev) => {
      // Prevent the default behaviour
      ev.preventDefault();
      // Close the sidebar
      closeSidebar(calc, table);
    });
  }

  /**
   * Open the sidebar
   */
  function openSidebar(calc, table) {
    // Get the sidebar button
    const sidebarButton = calc.querySelector(".calculator__cta a");
    // Exit if the sidebar button is disabled
    if (sidebarButton.classList.contains("button--disabled")) return;
    // Get the overlay
    const overlay = calc.querySelector(".calculator-overlay");
    // Get the sidebar
    const sidebar = calc.querySelector(".calculator-sidebar");
    // Add the open class to the sidebar and overlay
    sidebar.classList.add("calculator-sidebar--open");
    overlay.classList.add("calculator-overlay--open");
    // Add event listener to the overlay
    overlay.addEventListener("click", (ev) => {
      // Prevent the default behaviour
      ev.preventDefault();
      // Close the sidebar
      closeSidebar(calc, table);
    });
    // Add event listender to listen for submit
    listenForSubmit(calc, table);
  }

  /**
   * Close the sidebar
   */
  function closeSidebar(calc, table) {
    // Get the overlay
    const overlay = calc.querySelector(".calculator-overlay");
    // Get the sidebar
    const sidebar = calc.querySelector(".calculator-sidebar");
    // Remove the open class from the sidebar and overlay
    sidebar.classList.remove("calculator-sidebar--open");
    overlay.classList.remove("calculator-overlay--open");
    // Remove event listener from the overlay
    overlay.removeEventListener("click", (ev) => {
      // Prevent the default behaviour
      ev.preventDefault();
      // Close the sidebar
      closeSidebar(calc, table);
    });
    updateSidebarButton(calc);
    updateTotal(calc);
    hideCondfirmation(calc);
    setInitialDependencies(calc, table);
  }

  /**
   * Listen for submit
   */
  function listenForSubmit(calc, table) {
    // Get the submit button
    const submitButton = calc.querySelector(".calculator-sidebar__form .button");
    // Listen for clicks on the submit button
    submitButton.addEventListener("click", (ev) => {
      // Prevent the default behaviour
      ev.preventDefault();
      // Submit the form
      submitForm(calc, table);
    });
  }

  /**
   * Update the state of the submit button
   */
  function updateSubmitButton(calc) {
    // Get the submit button
    const submitButton = calc.querySelector(
      ".calculator-sidebar__form .button"
    );
    // Check if the button to open the sidebar is disabled
    const sidebarButton = calc.querySelector(".calculator__cta a");
    const sidebarEnabled = sidebarButton.classList.contains("button--disabled")
      ? false
      : true;
    // Check if the form is valid
    if (checkFormValidity(calc) && sidebarEnabled) {
      // Remove the disabled class from the submit button
      submitButton.classList.remove("button--disabled");
      // Remove the disabled attribute from the submit button
      submitButton.removeAttribute("disabled");
      // Exit the function
      return;
    }
    // Add the disabled class to the submit button
    submitButton.classList.add("button--disabled");
    // Add the disabled attribute to the submit button
    submitButton.setAttribute("disabled", true);
  }

  /**
   * Listen for changes on the form
   */
  function listenForFormChanges(calc) {
    // Get the form
    const form = calc.querySelector(".calculator-sidebar__form");
    // Get the fields
    const fields = form.querySelectorAll(".calculator-sidebar__form input");
    // Loop through all fields
    fields.forEach((field) => {
      // Listen for changes on the field
      field.addEventListener("change", (ev) => {
        // Update the state of the submit button
        updateSubmitButton(calc);
      });
    });
  }

  /**
   * Check if the form is valid
   */
  function checkFormValidity(calc) {
    // Get the form
    const form = calc.querySelector(".calculator-sidebar__form");
    // Get the fields
    const fields = form.querySelectorAll(".calculator-sidebar__form input");
    // Set variable for the result
    let result = true;
    // Loop through all fields
    fields.forEach((field) => {
      // Check if the field is valid
      if (!field.checkValidity()) {
        // Set the result to false
        result = false;
      }
    });
    // Return the result
    return result;
  }

  /**
   * Submit the form
   */
  function submitForm(calc, table) {
    // Get the submit button
    const submitButton = calc.querySelector(
      ".calculator-sidebar__form .button"
    );
    // Exit if the submit button is disabled
    if (submitButton.classList.contains("button--disabled")) return;
    // Get the form
    const form = calc.querySelector(".calculator-sidebar__form");
    // Get the url
    const url = form.action;
    // Get the method
    const method = form.method;
    // Get the data
    const data = getDataForRequest(calc);
    // Create a new request
    const request = new XMLHttpRequest();
    // Open the request
    request.open(method, url);
    // Listen for changes on the request
    request.addEventListener("readystatechange", (ev) => {
      // Check if the request is done
      if (request.readyState === 4) {
        // Handle the request
        handleRequest(request, calc, table);
      }
    });
    // Send the request
    request.send(data);
  }

  /**
   * Handle the request
   */
  function handleRequest(request, calc, table) {
    // Get the content of the response
    const response = request.responseText;
    // Check if the response is 'ok'
    if (response === "ok") {
      // Handle success
      return handleSuccess(calc, table);
    }
    // Handle error
    return handleError(calc);
  }

  /**
   * Handle success
   */
  function handleSuccess(calc, table) {
    showConfirmation(calc, table);
  }

  /**
   * Handle error
   */
  function handleError(calc) {
    console.log("error");
  }

  /**
   * Get the data for the request
   */
  function getDataForRequest(calc) {
    // Get the sidebar form
    const form = calc.querySelector(".calculator-sidebar__form");
    // Get the data from the form fields of the sidebar
    const data = new FormData(form);
    // Get a list of the ids of all the checked items of the calculator
    const ids = getCheckedItems(calc);
    // Get the calculator id
    const calculatorId = calc.dataset.calculatorId;
    // Add the ids to the data
    data.append("ids", ids);
    // Add the calculator id to the data
    data.append("calculator", calculatorId);
    // Return the data
    return data;
  }

  /**
   * Get a list of the ids of all the checked items of the calculator
   */
  function getCheckedItems(calc) {
    // Get all items of the calculator
    const items = calc.querySelectorAll(".calculator__item");
    // Set variable for the ids
    let ids = [];
    // Loop through all items
    items.forEach((item) => {
      // Get the input field
      const input = item.querySelector(".calculator__item-col--state input");
      // Exit if no input field is found or if the input field is not checked
      if (!input || !input.checked) return;
      // Get the id of the item
      const id = parseInt(item.dataset.itemId);
      // Add the id to the ids
      ids.push(id);
    });
    // Return the ids
    return ids;
  }

  /**
   * Show the confirmation
   */
  function showConfirmation(calc, table) {
    // Get the confirmation
    const confirmation = calc.querySelector(".calculator-sidebar__confirmation");
    // Get the bodytext in the sidebar
    const bodytext = calc.querySelector(".calculator-sidebar__bodytext");
    // Get the form in the sidebar
    const form = calc.querySelector(".calculator-sidebar__form");
    // Exit if one of the elements is not found
    if (!confirmation || !bodytext || !form) return;
    // Hide the bodytext
    bodytext.classList.add("hidden");
    // Hide the form
    form.classList.add("hidden");
    // Add the open class to the confirmation
    confirmation.classList.remove("hidden");
    // Clear the fields of the calculator
    // clearFields(calc);
    // Get the close button from the confirmation
    const closeButton = confirmation.querySelector(".calculator-sidebar__confirmation .button--close");
    // Exit if no close button is found
    if (!closeButton) return;
    // Listen for clicks on the close button
    closeButton.addEventListener("click", (ev) => {
      // Prevent the default behaviour
      ev.preventDefault();
      // Close the sidebar
      closeSidebar(calc, table);
    });
    // Get the cta button from the confirmation
    const ctaButton = confirmation.querySelector(".calculator-sidebar__confirmation .button--cta");
    // Exit if no cta button is found
    if (!ctaButton) return;
    // Listen for clicks on the cta button
    ctaButton.addEventListener("click", (ev) => {
      // Close the sidebar
      closeSidebar(calc, table);
    });
  }

  /**
   * Clear the fields of the calculator
   */
  function clearFields(calc) {
    // Get the calculator fields
    const fields = calc.querySelectorAll(".calculator__item-col input");
    // Loop through all fields
    fields.forEach((field) => {
      // Check if the field is checked
      if (field.checked) {
        // Uncheck the field
        field.checked = false;
      }
    });
  }

  /**
   * Hide the confirmation
   */
  function hideCondfirmation(calc) {
    // Get the confirmation
    const confirmation = calc.querySelector(".calculator-sidebar__confirmation");
    // Get the bodytext in the sidebar
    const bodytext = calc.querySelector(".calculator-sidebar__bodytext");
    // Get the form in the sidebar
    const form = calc.querySelector(".calculator-sidebar__form");
    // Exit if one of the elements is not found
    if (!confirmation || !bodytext || !form) return;
    // Hide the confirmation
    confirmation.classList.add("hidden");
    // Show the bodytext
    bodytext.classList.remove("hidden");
    // Show the form
    form.classList.remove("hidden");
  }
}

export default initializeCalculator;
